export const en = {
  // Header
  header: {
    home: "Home",
    products: "Products",
    about: "About",
    ourWorks: "Production",
    contact: "Contact",
    calculator: "Calculator",
    catalog: "Catalog",
  },
  // Banner
  banner: {
    title: "Premium steel manufacturing excellence",
    description:
      "Transform your projects with our high-quality steel products. From custom fabrication to standard profiles, we deliver precision engineering and exceptional service for every industrial need",
    contactUs: "Contact us",
    learnMore: "Learn more",
  },
  // WhoWeAre
  whoWeAre: {
    aboutUs: "About us",
    title: "Who we are",
    description:
      "MTA is a leading steel manufacturing company dedicated to delivering superior quality products and exceptional service. With decades of expertise in steel fabrication and processing, we combine traditional craftsmanship with modern technology to meet the diverse needs of industries across Kosovo and beyond.",
    learnMore: "Learn more",
    yearsOfExperience: "Years of experience",
    projectsPerYear: "Produces per year",
    clientSatisfaction: "Client satisfaction",
    tradesPerYear: "Tons per year",
  },
  // QuickAbout
  quickAbout: {
    profileMetalike: "Metalic profiles",
    profileMetalikeDesc:
      "We offer metal profiles in various dimensions: 15x15 - 140x140; fi 20 to fi150, thickness 0.9-5mm",
    slitingLine: "Sliting line",
    slitingLineDesc:
      "We cut sheet metal into strips with thickness 0.5mm to 10mm with width up to 1500mm",
    cutToLength: "Cut to length",
    cutToLengthDesc:
      "We cut sheet metal (plates), with thickness from 0.5-12mm, with various widths and lengths",
    pvc: "PVC",
    pvcDesc:
      "We produce all types of *metal profiles* for PVC doors and windows",
  },
  // Stats
  stats: {
    companyFounded: "Company founded",
    companyFoundedDesc:
      "MTA was established with a vision to provide high-quality steel products to the Kosovo market, starting with a small facility and dedicated team.",
    majorExpansion: "Major expansion",
    majorExpansionDesc:
      "Expanded our manufacturing capacity with state-of-the-art equipment and doubled our production facility to meet growing market demand.",
    industryLeadership: "Industry leadership",
    industryLeadershipDesc:
      "Became one of Kosovo's leading steel manufacturers, serving diverse industries with an extensive product range and unmatched quality standards.",
  },
  // Catalogue
  catalogue: {
    aboutUs: "About us",
    productCatalogue: "Product catalogue",
    rectangular: "Rectangular",
    rectangularDesc: "Durable shape ideal for frame structures",
    circular: "Circular",
    circularDesc: "Smooth and strong for curved applications",
    square: "Square",
    squareDesc: "Versatile design for general construction",
    profileU: "U Profile",
    profileUDesc: "Stable support for universal applications",
    profileH: "H Profile",
    profileHDesc:
      "Heavy-duty profile designed for maximum load-bearing capacity",
    elipse: "Elipse",
    elipseDesc: "Stylish shape for modern structural needs",
    profileP: "ZP Profile",
    profilePDesc: "Compact profile for precision-built systems",
    profileI: "I Profile",
    profileIDesc: "Lightweight profile offering maximum rigidity",
    roundBars: "Round Bars",
    roundBarsDesc:
      "Solid steel bars offering strength and precision for industrial use",
    profileL: "L Profile",
    profileLDesc:
      "Designed for strong support and reliable structural performance",
    flets: "Flats",
    fletsDesc: "Strong, smooth steel sheets for versatile fabrication use",
    learnMore: "Learn more",
  },
  // TradingProducts
  tradingProducts: {
    title: "Discover our trading products",
    description: "As a company, we trade these products in large quantities",
  },
  // Factory
  factory: {
    ourFactory: "Our factory",
    title: "What does our factory look like?",
    slide1:
      "Our main production hall features state-of-the-art machinery for cutting, forming, and finishing steel products with precision and efficiency",
    slide2:
      "Advanced quality control systems ensure every product meets international standards before leaving our facility.",
    slide3:
      "Our dedicated team of skilled professionals operates modern equipment to deliver consistent, high-quality results.",
    slide4:
      "Spacious warehouse facilities allow us to maintain extensive inventory and ensure rapid delivery to our clients.",
    slide5:
      "Our fabrication department handles custom projects with precision welding and assembly capabilities for complex steel structures.",
  },
  // ContactForm
  contactForm: {
    title: "Let's get in touch",
    titleHighlight: "Let's get",
    distributorDesc:
      "If you are a distributors who wish to partner with us. Fill in your details below, and our team will get in touch to discuss collaboration and bulk supply opportunities",
    customerDesc:
      "Whether you need product information, support, or just want to connect, we're here to help. Fill out your details, and our team will respond as quickly as possible.",
    distributor: "Distributor",
    customer: "Customer",
    name: "Name",
    surname: "Surname",
    email: "Email",
    phoneNumber: "Phone Number",
    message: "Message",
    uploadFile: "Upload file",
    noFileChosen: "No file chosen",
    submitForm: "Submit form",
  },
  // Footer
  footer: {
    trustedBy:
      "Trusted by hundreds of clients across the region for our commitment to quality, innovation, and reliable delivery.",
    contactUs: "Contact us",
    products: "Products",
    circular: "Circular",
    square: "Square",
    rectangular: "Rectangular",
    elipse: "Elipse",
    profileU: "U Profile",
    profileZ: "Z Profile",
    profileP: "ZP Profile",
    socialMedia:
      "You can also visit us in our social medias to see more about us",
    ourSocialMedia: "Our Social Media",
    allRightsReserved: "All Rights Reserved",
  },
  // Pages
  pages: {
    about: {
      title: "Our story, crafting quality in every alloy",
      description:
        "Discover our journey from a small steel workshop to one of Kosovo's premier manufacturing companies. Learn about our commitment to quality, innovation, and customer satisfaction",
    },
    products: {
      title: "Premium steel profiles for every application",
      description:
        "At MTA, we offer a comprehensive range of high-quality metal profiles designed to meet the diverse needs of industries across Kosovo and beyond. Combining precision engineering with durable materials, our products ensure reliability, strength, and performance for every project",
    },
    work: {
      title: "Our legacy of strength and precision",
      description:
        "Explore our steel fabrication factory serving Kosovo and the region. Equipped with modern machinery and skilled craftsmanship, MTA Steel delivers precise, durable, and high-quality steel fabrication solutions.",
    },
  },
  // Story
  story: {
    year1999:
      "Founded MTA with a vision to provide high-quality steel products to the local market, starting with basic profiles and custom fabrication services",
    year2003:
      "Expanded our product line to include specialized profiles and began serving larger industrial clients across Kosovo",
    year2007:
      "Invested in modern cutting and forming equipment, significantly increasing production capacity and product quality standards",
    year2010:
      "Doubled our facility size and introduced advanced quality control systems to meet international manufacturing standards",
    year2014:
      "Achieved ISO certification and began exporting products to neighboring countries, establishing MTA as a regional player",
    year2018:
      "Implemented automated production lines and digital inventory management, improving efficiency and customer service",
    year2021:
      "Expanded our team to over 50 skilled professionals and introduced eco-friendly manufacturing practices",
    year2023:
      "Launched our comprehensive online catalogue and customer portal, making it easier for clients to access our products",
    year2025:
      "Celebrating over 25 years of excellence, serving hundreds of clients with an extensive range of premium steel products",
  },
  // Values
  values: {
    ourValues: "Our values",
    title: "What we stand for",
    quality: "Quality",
    qualityDesc:
      "We never compromise on quality. Every product undergoes rigorous testing and inspection to ensure it meets the highest industry standards and exceeds customer expectations",
    innovation: "Innovation",
    innovationDesc:
      "We embrace advanced technologies and modern processes to continuously improve efficiency, precision, and performance in every product we deliver",
    integrity: "Integrity",
    integrityDesc:
      "We conduct every aspect of our business with honesty, transparency, and accountability. From sourcing materials to delivering final products, we honor our commitments, build trust with our partners, and uphold ethical standards in everything we do",
    excellence: "Excellence",
    excellenceDesc:
      "We conduct every aspect of our business with honesty, transparency, and accountability. From sourcing materials to delivering final products, we honor our commitments, build trust with our partners, and uphold ethical standards in everything we do",
  },
  // MainStats
  mainStats: {
    ourExpertise: "Our expertise",
    title: "We are certified and very advanced in what we do",
    description:
      "Our commitment to excellence is validated by international certifications and industry recognition. We maintain the highest standards in quality management, safety protocols, and environmental responsibility across all operations",
    iso9001: "ISO 9001",
    iso9001Desc:
      "Quality management system certification ensuring consistent quality in our manufacturing processes",
    oshaSafety: "OSHA Safety",
    oshaSafetyDesc:
      "Occupational safety and health administration certification for workplace safety standards",
    iso14001: "ISO 14001",
    iso14001Desc:
      "Environmental management system certification for sustainable manufacturing practices",
  },
  // QuickOverview
  quickOverview: {
    description:
      "MTA operates with 8 production lines, 4 of which are lines for the production of metal profiles, 2 sliter (sliting line), and 1 cutting in length (cut in line) of different sheet metal plates, production of metal profiles for doors and PVC windows",
  },
  // NewBorn
  newBorn: {
    description:
      "The iconic NEWBORN monument was proudly entrusted to our company for its fabrication and execution, marking a project of both technical complexity and symbolic value. Through precision steel manufacturing, structural expertise, and detailed finishing, we delivered a durable landmark that reflects creativity, strength, and modern design",
  },
  // Showroom
  showroom: {
    newbornMonument: "Newborn Monument",
    newbornMonumentDesc:
      "Supplied precision-cut steel letters for Kosovo's iconic NEWBORN monument, demonstrating our capability for complex architectural metalwork",
  },
  // Newsletter
  newsletter: {
    title: "Everything you need for your projects",
    description:
      "MTA provides complete steel solutions with extensive inventory, flexible customization options, and rapid delivery. Partner with us for reliable supply, technical expertise, and exceptional service throughout your project lifecycle",
    qualityAssurance: "Quality Assurance",
    qualityAssuranceDesc:
      "Premium materials and rigorous testing ensure the highest standards in every product we deliver",
    expertCraftsmanship: "Expert Craftsmanship",
    expertCraftsmanshipDesc:
      "Decades of experience combined with modern techniques to deliver exceptional results",
  },
  // SteelSupply
  steelSupply: {
    title: "We offer wholesale steel supply",
    description:
      "Our company provides wholesale quantities of steel products for distributors, construction companies, and large industrial projects. If you need bulk orders, consistent supply, or special pricing for high-volume purchases, our team is ready to support you with reliable and efficient service",
    contactUs: "Contact Us",
  },
  // Motivational
  motivational: {
    line1: "We don't just shape steel",
    line2: "we shape",
    line3: "STRENGTH ITSELF",
  },
};
